import React, { Component } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import Header from './components/core/header/header';
import Main from './components/core/main/main';
import Footer from './components/core/footer/footer';

// import logo from './assets/profile.png';
import './services/newsletters';
import './services/articles';
import './services/community';

import './app.css'; 


class App extends Component {
  constructor(props) {
    super(props);
    this.theme = createTheme();
  }

  render() {
    return (
      <ThemeProvider theme={this.theme}>
        <div className='app'>
          <div className='header-and-main-container'>
            <Header />
            <Main />

            <div className='transparent-area'></div>
            <div className='footer-push-trick'></div>
          </div>

          <Footer />
        </div>
      </ThemeProvider>
    )
  }
}

export default App;
